/* eslint-disable react-hooks/exhaustive-deps */
import {
  NizzaProductRequestOriginTypes,
  useAccount as useNizzaAccount,
  useNZ,
} from '@nizza/core';
import { createProductDataSource } from '@nizza/utils';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useFetchPlan } from '../plans';
import { externalAccountAtom } from './account.state';

export const useAccountInit = () => {
  const nizza = useNZ();
  const { isSuccess } = useNizzaAccount();
  const externalAccount = useAtomValue(externalAccountAtom);

  useFetchPlan();

  // externalAccount its used by global page
  useEffect(() => {
    if (!externalAccount) return;
    nizza.configure({ account: externalAccount });
  }, [externalAccount]);

  useEffect(() => {
    if (!isSuccess) return;
    const dataSource = createProductDataSource({
      origin: NizzaProductRequestOriginTypes.PLATFORM,
    });
    nizza.setProductDataSource(dataSource);
  }, [isSuccess]);
};
